module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/icon-f.5d4ec58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/resources/icon-f.png
// module id = ZUWi
// module chunks = 3 5